import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

import { btag, pushToDataLayer, SiteConfigManager } from '@atlas/core';

import { isLocalEnv, LocalConfig } from 'src/common/utils';
import { hasCustomGTM, initCustomGTM } from 'src/helpers/initCustomGTM';

const initDefaultGTM = () => {
  if (!isLocalEnv) {
    TagManager.initialize({
      gtmId: SiteConfigManager.getConfig('config.config.GTM'),
    });
  }
};

const GTMInitializer = () => {
  const projectId = LocalConfig.get('projectId');
  useEffect(() => {
    hasCustomGTM(projectId) ? initCustomGTM(projectId) : initDefaultGTM();

    pushToDataLayer('homepage', btag);
  }, [projectId]);

  return null;
};

export default GTMInitializer;
